export const blobToBase64 = (blob: Blob): Promise<string | ArrayBuffer | null> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}

/** Re-exported so canvas code can keep importing its sizing helper from here.
 *  The implementation is shared with the headless Playwright render, which has
 *  to size every canvas identically. */
export { calculateCanvasSize } from '@backend/lib/util/aspectRatio'

export const loadImageDimensionsFromUrl = (
  url: string,
): Promise<{ width: number; height: number }> =>
  new Promise((resolve, reject) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight })
    img.onerror = reject
    img.src = url
  })
